// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".booking-timeline-card[data-v-42e31064]{border:2px solid var(--q4s-neutral-250);padding:20px;border-radius:4px}", ""]);
// Exports
module.exports = exports;
